import React from 'react'
import Logins from './Logins'

function Login() {
    return (
        <div>
            <Logins />
        </div>
    )
}

export default Login